import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  'attendance.new': '新建',
  'attendance.edit': '编辑',
  'attendance.delete': '删除',
  'attendance.title': '考勤记录',
  'attendance.ID': 'ID',
  'attendance.staffId': '员工ID',
  'attendance.staff': '员工',
  'attendance.pleaseSelectAttendanceType': '请选择考勤类型',
  'attendance.attendanceTypePlaceholder': '选择考勤类型',
  'attendance.timestamp': '时间戳',
  'attendance.torranceMinutes': '容忍分钟',
  'attendance.expectedTime': '预期时间',
  'attendance.site': '物業',
  'attendance.shift': '班次',
  'attendance.checkpoint': '检查点',
  'attendance.requireOB': '需要OB编号',
  'attendance.createdAt': '创建时间',
  'attendance.updatedAt': '更新时间',
  'attendance.actions': '操作',
  'attendance.createAttendance': '新建考勤',
  'attendance.editAttendance': '编辑考勤',
  'attendance.cancel': '取消',
  'attendance.create': '创建',
  'attendance.update': '更新',
  'attendance.deleted': '考勤已删除',
  'attendance.deleteFailed': '删除考勤失败',
  'attendance.created': '考勤已创建',
  'attendance.updated': '考勤已更新',
  'attendance.saveFailed': '保存考勤失败',
  'attendance.deleteConfirm': '确定要删除此考勤吗？',
  'attendance.yes': '是',
  'attendance.no': '否',
  'attendance.pleaseSelectStaff': '请选择员工',
  'attendance.pleaseSelectSite': '请选择物業',
  'attendance.pleaseSelectShift': '请选择班次',
  'attendance.pleaseSelectCheckpoint': '请选择检查点',
  'attendance.pleaseInputShiftAssignmentId': '请输入班次分配ID',
  'attendance.pleaseSelectTimestamp': '请选择时间',
  'attendance.latitude': '纬度',
  'attendance.longitude': '经度',
  'attendance.ip': 'IP地址',
  'attendance.latitudeNumber': '纬度必须为数字',
  'attendance.longitudeNumber': '经度必须为数字',
  'attendance.latitudePlaceholder': '纬度（可选）',
  'attendance.longitudePlaceholder': '经度（可选）',
  'attendance.ipPlaceholder': 'IP地址（可选）',
  'attendance.shiftAssignmentId': '班次分配ID',
  'attendance.attendanceType': '考勤类型',
  'attendance.clockIn': '签到',
  'attendance.clockOut': '签退',
  'attendance.obNumber': 'OB编号',
  'attendance.patrol': '巡逻',
  'attendance.approvalStatus': '审批状态',
  'attendance.approved': '已批准',
  'attendance.rejected': '已拒绝',
  'attendance.pending': '待处理',
  'attendance.approvedBy': '批准人',
  'userManagement.showing': '显示',
  'userManagement.of': '共',
  'userManagement.items': '条',
  'checkpoint.create': '新建检查点',
  'checkpoint.edit': '编辑检查点',
  'checkpoint.name': '名称',
  'checkpoint.description': '描述',
  'checkpoint.referenceCode': '参考代码',
  'checkpoint.active': '启用',
  'checkpoint.cancel': '取消',
  'checkpoint.pleaseInputName': '请输入检查点名称',
  'checkpoint.pleaseInputReferenceCode': '请输入参考代码',
  'checkpoint.update': '更新',
  'incident.type.incident': '事件',
  'incident.type.maintenance': '维护',
  'incident.type.general': '一般',
  'incident.type.complain': '投诉',
  'attendance.showing': '显示',
  'attendance.of': '共',
  'attendance.items': '条',
  'incident.status.open': '开放',
  'incident.status.assigned': '已分配',
  'incident.status.inProgress': '进行中',
  'incident.status.reviewing': '审核中',
  'incident.status.resolved': '已解决',
  'incident.status.closed': '已关闭',
  'incident.severity.low': '低',
  'incident.severity.medium': '中',
  'incident.severity.high': '高',
  'incident.severity.critical': '严重',
  'incident.create.success': '事件创建成功',
  'incident.create.failed': '事件创建失败',
  'incident.management': '事件管理',
  'incident.kanban': '看板',
  'incident.calendar': '日历',
  'incident.addIncident': '添加事件',
  'incident.selectSite': '选择物業',
  'incident.type': '类型',
  'incident.status': '状态',
  'incident.severity': '严重程度',
  'incident.selectSitePrompt': '请选择物業以在看板或日历视图中查看日志。',
  'incident.addNewIncident': '添加新事件',
  'incident.create': '创建',
  'incident.logType': '日志类型',
  'incident.pleaseSelectLogType': '请选择日志类型',
  'incident.selectLogType': '选择日志类型',
  'incident.title': '标题',
  'incident.pleaseEnterTitle': '请输入标题',
  'incident.enterTitle': '输入标题',
  'incident.description': '描述',
  'incident.pleaseEnterDescription': '请输入描述',
  'incident.enterDescription': '输入描述',
  'incident.pleaseSelectSeverity': '请选择严重程度',
  'incident.selectSeverity': '选择严重程度',
  'incident.attachments': '附件（可选）',
  'incident.selectFiles': '选择文件',
  'incident.updateStatus': '更新状态',
  'incident.newState': '新状态',
  'incident.pleaseSelectNewState': '请选择新状态',
  'incident.assignTo': '分配给',
  'incident.pleaseSelectStaffToAssign': '请选择要分配的员工',
  'incident.notes': '备注',
  'incident.pleaseEnterNotes': '请输入备注',
  'incident.logDetails': '日志详情',
  'incident.currentState': '当前状态',
  'incident.loggedBy': '记录人',
  'incident.createdAt': '创建时间',
  'incident.stateChanges': '状态变更',
  'incident.changedStateFromTo': '状态从{from}变为{to}',
  'incident.assignedTo': '分配给：{name}',
  'incident.responses': '回复',
  'incident.edit': '编辑',
  'incident.pleaseEnterResponse': '请输入回复内容',
  'incident.addResponsePlaceholder': '添加回复...',
  'incident.updateResponse': '更新回复',
  'incident.addResponse': '添加回复',
  'incident.cancel': '取消',
  'shiftAssignment.siteShift': '物業 - 班次',
  'shiftAssignment.assigned': '已分配',
  'shiftAssignment.noSites': '未找到物業',
  'shiftAssignment.selectRegionDistrict': '请选择区域和地区',
  'shiftAssignment.filterByRegion': '按区域筛选',
  'shiftAssignment.filterByDistrict': '按地区筛选',
  'shiftAssignment.monthPicker': '选择月份',
  'shiftAssignment.importExcel': '导入Excel',
  'shiftAssignment.import': '导入',
  'shiftAssignment.selectFile': '选择Excel文件',
  'shiftAssignment.fileRequirements': '支持 .xlsx 和 .xls 文件，最大 10MB',
  'shiftAssignment.importSuccess': '导入成功完成',
  'shiftAssignment.importWithConflicts': '导入完成但有冲突',
  'shiftAssignment.importError': '导入失败',
  'shiftAssignment.invalidFileType': '只能上传Excel文件！',
  'shiftAssignment.fileTooLarge': '文件必须小于10MB！',
  'shiftAssignment.noFileSelected': '请选择要导入的文件',
  'shiftAssignment.importResult': '导入结果',
  'shiftAssignment.totalAssignments': '总分配数',
  'shiftAssignment.createdAssignments': '已创建分配',
  'shiftAssignment.skippedAssignments': '已跳过分配',
  'shiftAssignment.conflicts': '冲突',
  'shiftAssignment.conflictDetails': '冲突详情',
  'shiftAssignment.legend': '图例',
  'shiftAssignment.sunday': '周日',
  'shiftAssignment.holiday': '假期',
  'shiftAssignment.holidayName': '假期名称',
  'shiftAssignment.originalName': '原名',
  // Region translations
  'region.hongKong': '香港岛',
  'region.kowloon': '九龙',
  'region.newTerritories': '新界',
  // District translations
  'district.centralAndWestern': '中西区',
  'district.wanChai': '湾仔',
  'district.eastern': '东区',
  'district.southern': '南区',
  'district.yauTsimMong': '油尖旺',
  'district.shamShuiPo': '深水埗',
  'district.kowloonCity': '九龙城',
  'district.wongTaiSin': '黄大仙',
  'district.kwunTong': '观塘',
  'district.tuenMun': '屯门',
  'district.yuenLong': '元朗',
  'district.north': '北区',
  'district.taiPo': '大埔',
  'district.saiKung': '西贡',
  'district.shaTin': '沙田',
  'district.kwaiTsing': '葵青',
  'district.tsuenWan': '荃湾',
  'district.islands': '离岛',
  'shiftDetail.staff': '员工',
  'shiftDetail.notMapped': '未映射',
  'shiftDetail.employeeId': '员工编号',
  'shiftDetail.title': '职位',
  'shiftDetail.phone': '电话',
  'shiftDetail.overnight': '夜班',
  'shiftDetail.dayShift': '日班',
  'shiftDetail.manageStaff': '管理员工',
  'shiftDetail.noStaffMapped': '没有员工映射到此班次',
  'shiftDetail.assignToThisShift': '分配到此班次',
  'shiftDetail.assignToOtherShift': '分配到其他班次',
  'shiftDetail.markAsLeave': '标记为请假',
  'shiftDetail.removeAssignment': '移除分配',
  'shiftDetail.removeAssignmentConfirm': '确定要移除此分配吗？',
  'shiftDetail.cancelLeave': '取消请假',
  'shiftDetail.cancelLeaveConfirm': '确定要取消此请假吗？',
  'shiftDetail.yes': '是',
  'shiftDetail.no': '否',
  'shiftDetail.assignShift': '分配班次',
  'shiftDetail.assignToOtherShiftTitle': '分配到其他班次',
  'shiftDetail.confirmShiftAssignment': '确认分配班次？',
  'shiftDetail.addLeave': '添加请假',
  'shiftDetail.annualLeave': '年假',
  'shiftDetail.sickLeave': '病假',
  'shiftDetail.personalLeave': '事假',
  'shiftDetail.leaveReason': '请假原因',
  'shiftDetail.leaveAdded': '请假添加成功',
  'shiftDetail.leaveAddFailed': '添加请假失败',
  'shiftDetail.assignmentCreated': '分配创建成功',
  'shiftDetail.assignmentCreateFailed': '创建分配失败',
  'shiftDetail.assignmentDeleted': '分配删除成功',
  'shiftDetail.assignmentDeleteFailed': '删除分配失败',
  'shiftDetail.leaveCancelled': '请假已取消',
  'shiftDetail.leaveCancelFailed': '取消请假失败',
  'shiftDetail.currentStaff': '当前员工',
  'shiftDetail.name': '姓名',
  'shiftDetail.action': '操作',
  'shiftDetail.remove': '移除',
  'shiftDetail.addStaff': '添加员工',
  'shiftDetail.selectStaffToAdd': '选择要添加的员工',
  'shiftDetail.fetchStaffFailed': '获取可用员工失败',
  'shiftDetail.staffMapped': '员工映射成功',
  'shiftDetail.staffMapFailed': '员工映射失败',
  'shiftDetail.staffRemoved': '员工移除成功',
  'shiftDetail.staffRemoveFailed': '员工移除失败',
  'shiftDetail.fillAllFields': '请填写所有必填项',
  'shiftDetail.selectSiteAndShift': '选择物業和班次：',
  'shiftDetail.selectSite': '选择物業',
  'shiftDetail.selectShift': '选择班次',
  'menu.admin.asset-management': '资产管理',
  'siteDetail.title': '物業详情',
  'siteDetail.siteInformationTitle': '物業信息',
  'siteDetail.name': '名称',
  'siteDetail.shortName': '简称',
  'siteDetail.address': '地址',
  'siteDetail.district': '地区',
  'siteDetail.region': '区域',
  'siteDetail.status': '状态',
  'siteDetail.active': '启用',
  'siteDetail.inactive': '停用',
  'siteDetail.basicInformation': '基本信息',
  'siteDetail.siteID': '物業ID',
  'siteDetail.unitsTitle': '单元',
  'siteDetail.addUnit': '新增单元',
  'siteDetail.editUnit': '编辑单元',
  'siteDetail.deleteUnit': '删除单元',
  'siteDetail.unitNumber': '单元编号',
  'siteDetail.occupied': '已占用',
  'siteDetail.vacant': '空置',
  'siteDetail.occupiedLabel': '已占用',
  'siteDetail.vacantLabel': '空置',
  'siteDetail.action': '操作',
  'siteDetail.edit': '编辑',
  'siteDetail.delete': '删除',
  'siteDetail.addShift': '新增班次',
  'siteDetail.shiftsTitle': '班次',
  'siteDetail.shiftName': '班次名称',
  'siteDetail.time': '时间',
  'siteDetail.overnight': '通宵',
  'siteDetail.overnightShift': '通宵班次',
  'siteDetail.requiredHeadcount': '所需人数',
  'siteDetail.headcount': '人数',
  'siteDetail.assignedStaff': '已分配员工',
  'siteDetail.manageStaff': '管理员工',
  'siteDetail.manageShifts': '管理班次',
  'siteDetail.shiftUpdatedSuccess': '班次更新成功',
  'siteDetail.shiftCreatedSuccess': '班次创建成功',
  'siteDetail.operationFailed': '操作失败',
  'siteDetail.checkpointManagementTitle': '巡查点管理',
  'siteDetail.addCheckpoint': '新增巡查点',
  'siteDetail.referenceCode': '参考代码',
  'siteDetail.description': '描述',
  'siteDetail.activeLabel': '启用',
  'siteDetail.inactiveLabel': '停用',
  'siteDetail.checkpointCreated': '巡查点创建成功',
  'siteDetail.checkpointUpdated': '巡查点更新成功',
  'siteDetail.checkpointSaveFailed': '保存巡查点失败',
  'siteDetail.contactNumbersTitle': '联系电话',
  'siteDetail.addPhone': '新增电话',
  'siteDetail.phoneNumber': '电话号码',
  'siteDetail.phoneAddedSuccess': '电话添加成功',
  'siteDetail.phoneUpdatedSuccess': '电话更新成功',
  'siteDetail.phoneDeletedSuccess': '电话删除成功',
  'siteDetail.fetchSiteDetailsError': '获取物業详情失败',
  'siteDetail.fetchUnitsError': '获取单元失败',
  'siteDetail.fetchLogsError': '获取日志失败',
  'siteDetail.logCreatedSuccess': '日志创建成功',
  'siteDetail.logUpdatedSuccess': '日志更新成功',
  'siteDetail.logResolveFailed': '日志结案失败',
  'siteDetail.logResolvedSuccess': '日志结案成功',
  'siteDetail.unitCreatedSuccess': '单元创建成功',
  'siteDetail.unitUpdatedSuccess': '单元更新成功',
  'siteDetail.unitDeletedSuccess': '单元删除成功',
  'siteDetail.unitSaveFailed': '保存单元失败',
  'siteDetail.unitDeleteFailed': '删除单元失败',
  'siteDetail.addLog': '新增日志',
  'siteDetail.recentLogsTitle': '最新日志',
  'siteDetail.logType': '日志类型',
  'siteDetail.incident': '事件',
  'siteDetail.maintenance': '维护',
  'siteDetail.general': '一般',
  'siteDetail.complain': '投诉',
  'siteDetail.severity': '严重程度',
  'siteDetail.low': '低',
  'siteDetail.medium': '中',
  'siteDetail.high': '高',
  'siteDetail.critical': '严重',
  'siteDetail.status': '状态',
  'siteDetail.open': '未处理',
  'siteDetail.inProgress': '处理中',
  'siteDetail.resolved': '已解决',
  'siteDetail.closed': '已关闭',
  'siteDetail.createdBy': '创建人',
  'siteDetail.createdAt': '创建时间',
  'siteDetail.resolution': '解决方案',
  'siteDetail.resolvedBy': '解决人',
  'siteDetail.resolvedAt': '解决时间',
  'siteDetail.viewDetails': '查看详情',
  'siteDetail.updateStatus': '更新状态',
  'siteDetail.logDetailsTitle': '日志详情 - {title}',
  'siteDetail.currentState': '当前状态',
  'siteDetail.loggedBy': '记录人',
  'siteDetail.stateChanges': '状态变更',
  'siteDetail.changedStateFrom': '状态从',
  'siteDetail.to': '变为',
  'siteDetail.assignedTo': '分配给',
  'siteDetail.responses': '回复',
  'siteDetail.addResponse': '添加回复',
  'siteDetail.updateResponse': '更新回复',
  'siteDetail.cancel': '取消',
  'siteDetail.pleaseEnterResponse': '请输入回复内容',
  'siteDetail.responseAddedSuccess': '回复添加成功',
  'siteDetail.responseAddFailed': '添加回复失败',
  'siteDetail.responseUpdatedSuccess': '回复更新成功',
  'siteDetail.responseUpdateFailed': '回复更新失败',
  'siteDetail.manageShiftPreferencesTitle': '管理班次偏好 - {employee_id}',
  'siteDetail.preferredShifts': '偏好班次',
  'siteDetail.selectShifts': '请选择班次',
  'siteDetail.currentPreferences': '当前偏好',
  'siteDetail.remove': '移除',
  'siteDetail.preferencesUpdatedSuccess': '偏好更新成功',
  'siteDetail.preferencesUpdateFailed': '偏好更新失败',
  'siteDetail.preferenceRemovedSuccess': '偏好移除成功',
  'siteDetail.preferenceRemoveFailed': '偏好移除失败',
  'siteDetail.fetchPreferencesError': '获取偏好失败',
  'siteDetail.manageStaffTitle': '管理员工 - {name}',
  'siteDetail.assignStaff': '分配员工',
  'siteDetail.assignStaffTitle': '分配员工',
  'siteDetail.selectStaff': '选择员工',
  'siteDetail.selectStaffToAssign': '请选择要分配的员工',
  'siteDetail.assignStaffWarning': '部分员工无法分配: {staff_ids}',
  'siteDetail.assignStaffSuccess': '成功分配 {mapped_staff_count} 名员工',
  'siteDetail.assignStaffError': '分配员工失败',
  'siteDetail.fetchStaffListError': '获取员工列表失败',
  'siteDetail.loading': '加载中...',
  'siteDetail.employeeID': '员工编号',
  'siteDetail.type': '类型',
  'siteDetail.complain': '投诉',
  'siteDetail.deletePhoneTitle': '删除电话',
  'siteDetail.deletePhoneConfirm': '确定要删除此电话号码吗？',
  'siteDetail.fetchPreferencesError': '获取偏好设置失败',
  'siteDetail.preferencesUpdatedSuccess': '偏好设置更新成功',
  'siteDetail.preferencesUpdateFailed': '偏好设置更新失败',
  'siteDetail.preferenceRemovedSuccess': '偏好设置移除成功',
  'siteDetail.preferenceRemoveFailed': '偏好设置移除失败',
  'siteDetail.assignStaffWarning': '请选择要分配的员工',
  'siteDetail.assignStaffSuccess': '员工分配成功',
  'siteDetail.assignStaffError': '员工分配失败',
  'siteDetail.deleteUnitTitle': '删除单元',
  'siteDetail.deleteUnitConfirm': '确定要删除此单元吗？',
  'siteDetail.patrolRouteCreated': '巡逻路线创建成功',
  'siteDetail.patrolRouteUpdated': '巡逻路线更新成功',
  'siteDetail.patrolRouteSaveFailed': '巡逻路线保存失败',
  'siteDetail.deletePatrolRouteTitle': '删除巡逻路线',
  'siteDetail.deletePatrolRouteConfirm': '确定要删除此巡逻路线吗？',
  'siteDetail.patrolRouteDeleted': '巡逻路线删除成功',
  'siteDetail.patrolRouteDeleteFailed': '巡逻路线删除失败',
  'siteDetail.fetchPatrolRouteCheckpointsError': '获取巡逻路线检查点失败',
  'siteDetail.accessDenied': '无权限访问',
  'siteDetail.editShiftTitle': '编辑班次',
  'siteDetail.editPhoneTitle': '编辑电话',
  'siteDetail.updateLogTitle': '更新日志',
  'unitModal.editTitle': '编辑单元',
  'unitModal.addTitle': '新增单元',
  'unitModal.occupied': '已占用',
  'unitModal.availableTenants': '可用租户',
  'unitModal.assignedTenants': '已分配租户',
  'unitModal.tenantName': '租户名称',
  'unitModal.phoneNumber': '电话号码',
  'unitModal.leaseStart': '租赁开始',
  'unitModal.leaseEnd': '租赁结束',
  'unitModal.createTenant': '创建租户',
  'unitModal.fetchUnitTenantsError': '获取单元租户失败',
  'unitModal.fetchAllTenantsError': '获取所有租户失败',
  'unitModal.createTenantSuccess': '租户创建成功',
  'unitModal.createTenantError': '创建租户失败',
  'welcome.learnMore': '了解更多',
  'welcome.shiftAttendanceToday': '今日班次考勤',
  'welcome.site': '物業',
  'welcome.siteShortName': '简称',
  'welcome.shift': '班次',
  'welcome.staff': '员工',
  'welcome.shiftStart': '班次开始',
  'welcome.attendance': '考勤',
  'welcome.checkedInAt': '已签到 {time}',
  'welcome.noAttendanceLate': '未签到（迟到）',
  'welcome.noAttendance': '未签到',
  'welcome.latestUnclosedIncidents': '最新未结案事件',
  'welcome.totalUnclosed': '未结案总数：{count}',
  'welcome.low': '低：{count}',
  'welcome.medium': '中：{count}',
  'welcome.high': '高：{count}',
  'welcome.title': '标题',
  'welcome.severity': '严重程度',
  'welcome.state': '状态',
  'welcome.createdAt': '创建时间',
  'welcome.loggedBy': '记录人',
  'siteManagement.title': '物業管理',
  'siteManagement.content': '管理所有物業，包括创建、编辑和搜索。',
  'siteManagement.addNewSite': '新增物業',
  'siteManagement.siteList': '物業列表',
  'siteManagement.name': '名称',
  'siteManagement.shortName': '简称',
  'siteManagement.address': '地址',
  'siteManagement.region': '区域',
  'siteManagement.district': '地区',
  'siteManagement.status': '状态',
  'siteManagement.active': '启用',
  'siteManagement.inactive': '停用',
  'siteManagement.shifts': '班次',
  'siteManagement.action': '操作',
  'siteManagement.edit': '编辑',
  'siteManagement.viewDetails': '查看详情',
  'siteManagement.addSite': '新增物業',
  'siteManagement.editSite': '编辑物業',
  'siteManagement.siteName': '物業名称',
  'siteManagement.pleaseEnterSiteName': '请输入物業名称',
  'siteManagement.pleaseEnterShortName': '请输入简称',
  'siteManagement.shortNameMax': '简称不能超过10个字符',
  'siteManagement.shortNameTooltip': '用于快速识别的简称，最多10个字符',
  'siteManagement.pleaseEnterAddress': '请输入地址',
  'siteManagement.pleaseSelectRegion': '请选择区域',
  'siteManagement.pleaseSelectDistrict': '请选择地区',
  'siteManagement.searchName': '按名称搜索',
  'siteManagement.searchShortName': '按简称搜索',
  'siteManagement.searchAddress': '按地址搜索',
  'siteManagement.createSuccess': '物業创建成功',
  'siteManagement.updateSuccess': '物業更新成功',
  'siteManagement.operationFailed': '操作失败',
  'siteManagement.showing': '显示',
  'siteManagement.of': '共',
  'siteManagement.items': '条',
  'siteManagement.shiftCalendar': '班次日历',
  'siteManagement.viewShiftCalendar': '查看班次日历',
  'siteDetail.addNewShift': '新增班次',
  'siteDetail.addNewPhone': '新增电话',
  'siteDetail.addNewLog': '新增日志',
  'siteDetail.addNewUnit': '新增单元',
  'siteDetail.addNewCheckpoint': '新增巡查点',
  'siteDetail.editCheckpointTitle': '编辑巡查点',
  'siteDetail.editUnitTitle': '编辑单元',
  'siteDetail.deleteConfirm': '确定要删除此项吗？',
  'siteDetail.saveSuccess': '保存成功',
  'siteDetail.saveFailed': '保存失败',
  'siteDetail.deleteSuccess': '删除成功',
  'siteDetail.deleteFailed': '删除失败',
  'siteDetail.addResponse': '添加回复',
  'siteDetail.updateResponse': '更新回复',
  'siteDetail.cancel': '取消',
  'siteDetail.pleaseEnter': '请输入',
  'siteDetail.pleaseSelect': '请选择',
  'staffLeave.title': '员工请假管理',
  'staffLeave.headerTitle': '请假记录',
  'staffLeave.employeeId': '员工编号',
  'staffLeave.staffName': '员工姓名',
  'staffLeave.phone': '电话',
  'staffLeave.leaveType': '请假类型',
  'staffLeave.reason': '原因',
  'staffLeave.date': '日期',
  'staffLeave.status': '状态',
  'staffLeave.approvedBy': '审批人',
  'staffLeave.approvedAt': '审批时间',
  'staffLeave.actions': '操作',
  'staffLeave.approveConfirm': '确认批准该请假吗？',
  'staffLeave.rejectConfirm': '确认拒绝该请假吗？',
  'staffLeave.approved': '已批准',
  'staffLeave.pending': '待审批',
  'staffLeave.rejected': '已拒绝',
  'staffLeave.approveSuccess': '请假已批准',
  'staffLeave.rejectSuccess': '请假已拒绝',
  'staffLeave.updateFailed': '更新请假失败',
  'staffLeave.searchEmployeeId': '搜索员工编号',
  'staffLeave.searchName': '搜索姓名',
  'staffLeave.searchPhone': '搜索电话',
  'leave.annual': '年假',
  'leave.sick': '病假',
  'leave.personal': '事假',
  'leave.other': '其他',
  'userManagement.title': '用户管理',
  'userManagement.content': '管理用户账户及其状态',
  'userManagement.userList': '用户列表',
  'userManagement.createNewUser': '新建用户',
  'userManagement.editUser': '编辑用户',
  'userManagement.createUser': '新建用户',
  'userManagement.resetPassword': '重置密码',
  'userManagement.username': '用户名',
  'userManagement.email': '邮箱',
  'userManagement.role': '角色',
  'userManagement.status': '状态',
  'userManagement.active': '启用',
  'userManagement.inactive': '停用',
  'userManagement.createdAt': '创建时间',
  'userManagement.lastLogin': '最后登录',
  'userManagement.actions': '操作',
  'userManagement.newPassword': '新密码',
  'userManagement.searchUsername': '搜索用户名',
  'userManagement.searchEmail': '搜索邮箱',
  'userManagement.pleaseInputUsername': '请输入用户名！',
  'userManagement.pleaseInputEmail': '请输入邮箱！',
  'userManagement.password': '密码',
  'userManagement.pleaseInputPassword': '请输入密码！',
  'userManagement.leaveEmptyToKeepCurrent': '留空以保持当前密码',
  'userManagement.pleaseSelectRole': '请选择角色！',
  'userManagement.pleaseInputNewPassword': '请输入新密码！',
  'userManagement.userUpdated': '用户更新成功',
  'userManagement.userCreated': '用户创建成功',
  'userManagement.saveUserFailed': '保存用户失败',
  'transaction.title': '交易记录',
  'transaction.create': '创建交易',
  'transaction.edit': '编辑交易',
  'transaction.description': '描述',
  'transaction.amount': '金额',
  'transaction.currency': '货币',
  'transaction.category': '类别',
  'transaction.unit': '单位',
  'transaction.status': '状态',
  'transaction.transactionDate': '交易日期',
  'transaction.attachment': '附件',
  'transaction.createdAt': '创建时间',
  'transaction.actions': '操作',
  'transaction.referenceType': '参考类型',
  'transaction.referenceId': '参考ID',
  'transaction.protected': '受保护',
  'transaction.uploadImage': '上传图片',
  'transaction.selectCategory': '选择类别',
  'transaction.selectUnit': '选择单位',
  'transaction.descriptionRequired': '请输入描述',
  'transaction.amountRequired': '请输入金额',
  'transaction.createSuccess': '交易创建成功',
  'transaction.updateSuccess': '交易更新成功',
  'transaction.operationFailed': '交易操作失败',
  'transaction.createTitle': '创建交易',
  'transaction.editTitle': '编辑交易',
  'transaction.income': '收入',
  'transaction.expense': '支出',
  'transaction.status.pending': '待处理',
  'transaction.status.approved': '已批准',
  'transaction.status.rejected': '已拒绝',
  'transaction.status.cancelled': '已取消',
  'userManagement.passwordResetSuccess': '密码重置成功',
  'userManagement.passwordResetFailed': '密码重置失败',
  'userManagement.updateStatusFailed': '更新用户状态失败',
  'userManagement.fetchRolesFailed': '获取角色失败',
  'userManagement.accessDenied': '无权限访问',
  'userManagement.oneTimePassword': '一次性密码',
  'userManagement.faceRecognition': '人脸识别',
  'userManagement.fetchTokensFailed': '获取令牌失败',
  'userManagement.tokenCreated': '令牌创建成功',
  'userManagement.createTokenFailed': '创建令牌失败',
  'userManagement.copiedToClipboard': '已复制到剪贴板',
  'userManagement.copyFailed': '复制失败',
  'userManagement.tokenUpdated': '令牌更新成功',
  'userManagement.updateTokenFailed': '更新令牌失败',
  'userManagement.tokenActivated': '令牌启用成功',
  'userManagement.tokenDeactivated': '令牌停用成功',
  'userManagement.tokenStatusToggleFailed': '更新令牌状态失败',
  'userManagement.qrCodeGenerationFailed': 'QR码生成失败',
  'userManagement.oneTimePasswordTitle': '一次性密码管理',
  'userManagement.tokenDescription': '令牌描述',
  'userManagement.tokenDescriptionPlaceholder': '输入令牌描述（可选）',
  'userManagement.expiresInHours': '过期时间（小时）',
  'userManagement.createToken': '创建令牌',
  'userManagement.newTokenCreated': '新令牌已创建',
  'userManagement.copy': '复制',
  'userManagement.tokenWarning': '请务必保存此令牌，因为它只会显示一次！',
  'userManagement.token': '令牌',
  'userManagement.description': '描述',
  'userManagement.noDescription': '无描述',
  'userManagement.used': '已使用',
  'userManagement.expired': '已过期',
  'userManagement.valid': '有效',
  'userManagement.expiresAt': '过期时间',
  'userManagement.usedAt': '使用时间',
  'userManagement.copyToken': '复制令牌',
  'userManagement.qrCode': 'QR码',
  'userManagement.generateQRCode': '生成QR码',
  'userManagement.qrCodeTitle': 'QR码 - 一次性令牌',
  'userManagement.download': '下载',
  'userManagement.print': '打印',
  'userManagement.close': '关闭',
  'userManagement.authenticationURL': '认证URL',
  'userManagement.requestBody': '请求内容',
  'userManagement.tokenInfo': '令牌信息',
  'userManagement.qrCodeInstructions': '扫描此QR码以使用一次性令牌进行认证',
  'staffManagement.title': '员工管理',
  'staffManagement.staffList': '员工列表',
  'staffManagement.addStaff': '添加员工',
  'staffManagement.editStaff': '编辑员工',
  'staffManagement.employeeId': '员工编号',
  'staffManagement.name': '姓名',
  'staffManagement.lastName': '姓氏',
  'staffManagement.gender': '性别',
  'staffManagement.phone': '电话',
  'staffManagement.site': '物業',
  'staffManagement.status': '状态',
  'staffManagement.action': '操作',
  'staffManagement.active': '在职',
  'staffManagement.inactive': '离职',
  'staffManagement.firstName': '名字',
  'staffManagement.titleLabel': '称谓',
  'staffManagement.mr': '先生',
  'staffManagement.mrs': '夫人',
  'staffManagement.ms': '女士',
  'staffManagement.dr': '博士',
  'staffManagement.dateOfBirth': '出生日期',
  'staffManagement.address': '地址',
  'staffManagement.emergencyContact': '紧急联系人',
  'staffManagement.emergencyPhone': '紧急联系电话',
  'staffManagement.pleaseInputEmployeeId': '请输入员工编号！',
  'staffManagement.pleaseInputFirstName': '请输入名字！',
  'staffManagement.pleaseInputLastName': '请输入姓氏！',
  'staffManagement.pleaseSelectGender': '请选择性别！',
  'staffManagement.pleaseInputPhone': '请输入电话！',
  'staffManagement.pleaseInputAddress': '请输入地址！',
  'staffManagement.pleaseInputEmergencyContact': '请输入紧急联系人！',
  'staffManagement.pleaseInputEmergencyPhone': '请输入紧急联系电话！',
  'staffManagement.staffCreated': '员工创建成功',
  'staffManagement.staffUpdated': '员工更新成功',
  'staffManagement.operationFailed': '操作失败',
  'staffManagement.accessDenied': '无权限访问',
  'staffManagement.searchEmployeeId': '搜索员工编号',
  'staffManagement.searchFirstName': '搜索名字',
  'staffManagement.searchLastName': '搜索姓氏',
  'staffManagement.searchPhone': '搜索电话',
  'staffManagement.filterBySite': '按物業筛选',
  'staffManagement.male': '男',
  'staffManagement.female': '女',
  'staffManagement.other': '其他',
  'dashboard.siteAttendanceSummary': '物業考勤摘要',
  'dashboard.date': '日期',
  'dashboard.selectDate': '選擇日期',
  'dashboard.attendance': '考勤',
  'dashboard.obRecords': 'OB',
  'dashboard.patrolRoutes': '巡邏',
  'dashboard.completed': '已完成',
  'dashboard.pending': '待處理',
  'dashboard.total': '總計',
  'dashboard.noSites': '未找到物業',
  'dashboard.loading': '正在載入考勤數據...',
  'dashboard.noSitesDesc': '請嘗試選擇其他日期或檢查物業配置',
  'dashboard.refresh': '刷新',
  'dashboard.unknownDistrict': '未知區域',
  'dashboard.unknownRegion': '未知地區',
  'dashboard.noData': '無數據',
  'dashboard.byDistrict': '按區域',
  'dashboard.byRegion': '按地區',
};
